/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from '@emotion/react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';

export type OrgPropertyPageNewStyles = {
  root: SerializedStyles;
};

export const DEFAULT_ORG_PROPERTY_PAGE_NEW_STYLES: OrgPropertyPageNewStyles = {
  /* PageLayout's content area is a fixed-height flex column that scrolls. Nothing here may shrink
     to fit it: the tables keep their full height and the page scrolls as a whole, rather than
     each table scrolling inside itself. */
  root: css`
    label: ORG_PROPERTY_PAGE_NEW;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 18px 20px 32px;
    background: ${COLORS.paper};
    min-height: 100%;
    box-sizing: border-box;

    & > * {
      flex-shrink: 0;
    }
  `,
};
